import { CommentAlertIcon } from './CommentAlertIcon';

/**
 * author: Austin Andrews
 * id 04CF8C3D-0D65-41CA-8D0D-53DD7EAB25B8
 * name comment-alert
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/comment-alert.svg
 * tags
 * - Alert / Error 
 */
export const CommentWarningIcon = CommentAlertIcon;
export default CommentWarningIcon